import { render, staticRenderFns } from "./ListRingTreeTargetRequests.vue?vue&type=template&id=4d6422fc&scoped=true"
import script from "./ListRingTreeTargetRequests.vue?vue&type=script&lang=js"
export * from "./ListRingTreeTargetRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6422fc",
  null
  
)

export default component.exports